// extracted by mini-css-extract-plugin
export default {"nav_box":"index_nav_box_Hi-TF","nav_list":"index_nav_list_frY29","sub_nav":"index_sub_nav_fgNif clearfix"};